<template>
	<modal ref="modal" size='modal-xl'>
		<template #title>Member - Special Discount</template>
		<template #body>
			<div class="mb-4 text-center">
				<span class="btn btn-outline-info py-2 px-4 disabled">{{member.current_rank}}</span>
			</div>
			<div class="mb-4 text-center">
				<span>{{member.expiry_format}}</span>
			</div>
			<div class="mb-4">
				<label class="form-label" for="amount">Email Address</label>
				<div class="form-control">{{member.username}}</div>
			</div>
			<!-- <div v-if="member.is_expired==1"> -->
			<div>
				<div class="mb-4">
					<label class="form-label" for="amount">Membership Level</label>
					<select v-model="form.membership_level" class="form-select">
						<option value="ALL">ALL</option>
						<option value="SILVER">SILVER</option>
						<option value="GOLD">GOLD</option>
						<option value="DIAMOND">DIAMOND</option>
						<option value="PLATINUM">PLATINUM</option>
						<option value="PLATINUM COUPLE">PLATINUM COUPLE</option>
					</select>
				</div>
				<div class="mb-4">
					<label class="form-label" for="amount">Applicable for Mininum Month</label>
					<select v-model="form.min_month" class="form-select">
						<option value="3">3 Months</option>
						<option value="6">6 Months</option>
						<option value="12">12 Months</option>
					</select>
				</div>
				<div class="form-floating mb-4">
					<select
						v-model="form.discount_type"
						id="discount_type"
						class="form-select"
						placeholder="Select Discount Type"
						:class="{ 'is-invalid': form.errors.discount_type }"
					>
						<option value="amount">Amount</option>
						<option value="percentage">Percentage</option>
					</select>
					<label class="form-label" for="amount">Discount Type</label>
				</div>
				<div class="form-floating mb-4">
					<input v-model="form.amount" type="text" name="amount" class="form-control" placeholder="Amount"/>
					<label class="form-label" for="amount">Amount</label>
				</div>
				<div class="my-5 form-group text-center">
					<button
						@click="createSpecialDiscount"
						type="submit"
						class="btn btn-alt-primary"
						:disabled="form.processing || form.amount==0 || form.amount==''"
					>
						<div
							v-if="form.processing"
							class="spinner-border spinner-border-sm text-dark me-1"
							role="status"
						>
							<span class="sr-only">Processing...</span>
						</div>
						<span>Create Special Discount</span>
					</button>
				</div>
			</div>

			<div class="border-bottom h4 block-header p-0">
				List
				<div class="btn-block-option">
					<button @click="refreshExpiredDiscount" type="button" class="btn btn-sm btn-info">
						<div
							v-if="formReload.processing"
							class="spinner-border spinner-border-sm text-white me-1"
							role="status"
						>
							<span class="sr-only">Processing...</span>
						</div>
						<i v-else class="si si-refresh me-1"></i>
						<span>Refresh</span>
					</button></div>
			</div>
			<div class="table-responsive">
				<table class="table">
					<thead>
						<tr>
							<th>Membership</th>
							<th>Type</th>
							<th>Amount</th>
							<th>Activate</th>
							<th>Visisted</th>
							<th>Client_Ip</th>
							<th>Admin_Ip</th>
							<th>Status</th>
							<th>Active</th>
							<th>Created</th>
							<th>Updated</th>
							<th class="text-end">::::</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(expired, e_index) in expiredDiscount">
							<td>
								<span class="fw-bold">{{expired.membership_level}}</span>
								<div class="text-danger"><sub>Applicable for Mininum of {{expired.min_month}} Months</sub></div>
							</td>
							<td>{{expired.discount_type}}</td>
							<td>{{expired.amount}}</td>
							<td>
								<sub class="text-danger">Client:<br/>Re-Activation Attempt: {{expired.activate_cnt}}</sub>
							</td>
							<td>{{expired.access_cnt}}</td>
							<td>{{expired.ip_address}}</td>
							<td>{{expired.admin_ipaddress}}</td>
							<td nowrap="">
								<span :class="{'text-success':expired.status=='Renewed','text-warning':expired.status=='Pending','text-danger':expired.status=='Expired'}" class="text-success">{{expired.status}}</span>
								<div v-if="expired.is_active==1 && expired.status=='Expired' && e_index==0"><button @click="resetToPending(e_index)" type="button" class="btn btn-sm btn-outline-danger fs-xs py-0" title="Re-Activation Confirmation"><i class="fa fa-retweet me-1"></i>Reset</button></div>
							</td>
							<td>
								<span v-if="expired.is_active==1" class="text-success">Yes</span>
								<span v-else class="text-danger">No</span>
							</td>
							<td>{{expired.created_format}}</td>
							<td>{{expired.updated_format}}</td>
							<td class="text-end">
								<input type="text" :id="'expired_link-'+e_index" :value="expired.expired_link" style="position: absolute;left: -1000px;">
								<button @click="selectExpiredDiscount(e_index)" :disabled="expired.status=='Renewed' || e_index!=0" type="button" class="btn btn-sm btn-info" title="Edit Details"><i class="fa fa-edit"></i></button>
								<button @click="copyLink(e_index)" :disabled="expired.status=='Renewed' || e_index!=0" type="button" class="btn btn-sm btn-warning mt-1" title="Copy the link"><i class="fa fa-link"></i></button>
								<button @click="reSendEmail(e_index)" :disabled="formResend.processing || expired.status=='Renewed' || e_index!=0 || expired.is_active==0" type="button" class="btn btn-sm btn-success mt-1" title="Re-Send Email">
									<div
										v-if="formResend.processing && current_index==e_index"
										class="spinner-border spinner-border-sm text-dark me-1"
										role="status"
									>
										<span class="sr-only">Processing...</span>
									</div>
									<i v-else class="fa fa-envelope"></i>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template #footer>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>

	<update-expired-discount ref="updateExpiredDiscountModal"/>

	<modal ref="confirmReActivateModal" size="shadow border">
		<template #title>Re-Activation Confirmation</template>
		<template #body>
			<p class="fw-bold">Are you sure, you want to re-activate this special discount?</p>
		</template>
		<template #footer>
			<button
				@click="reActivation"
				type="button"
				class="btn btn-alt-success"
				:disabled="formReActivate.processing"
			>
				<div
					v-if="formReActivate.processing"
					class="spinner-border spinner-border-sm text-dark me-1"
					role="status"
				>
					<span class="sr-only">Processing...</span>
				</div>
				<i v-else class="fa fa-retweet me-1"></i>
				<span>
					Re-Activation
				</span>
			</button>
			<button
				@click="confirmReActivateModal.toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="formReActivate.processing"
			>
				Close
			</button>
		</template>
	</modal>

</template>

<script>
import { ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import UpdateExpiredDiscount from './UpdateExpiredDiscount'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster'

export default {
	props: {
		admin: Object,
		member: Object,
		expiredDiscount: Object,
	},
	components: {UpdateExpiredDiscount},
	setup(props) {

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const confirmReActivateModal 		= ref(null);

		const updateExpiredDiscountModal 	= ref(null);

		const form = useForm({
			generated_by: props.admin.fname,
			member_id: props.member.counter,
			username: props.member.username,
			fname: props.member.fname,
			membership_level: props.member.current_rank,
			min_month: 3,
			discount_type: 'amount',
			amount: 0,
			is_expired: props.member.is_expired
		})

		const formReload = useForm({});

		const formReActivate = useForm({
			expired_discount_id : 0,
			status 				: '',
			generated_by 		: props.admin.fname,
			username 			: props.member.username,
			fname 				: props.member.fname,
			special_code 		: props.member.special_code,
		});

		const formResend = useForm({
			username 		: '',
			special_code 	: '',
			generated_by 	: '',
			fname 			: '',
		});

		const selectedExpiredDiscount = reactive({});

		const selectExpiredDiscount = (_index)=>{
			let selected_data = props.expiredDiscount[_index];

			selectedExpiredDiscount.expired_discount_id 	= selected_data.expired_discount_id;
			selectedExpiredDiscount.membership_level 		= selected_data.membership_level;
			selectedExpiredDiscount.min_month 				= selected_data.min_month;
			selectedExpiredDiscount.discount_type 			= selected_data.discount_type;
			selectedExpiredDiscount.amount 					= selected_data.amount;
			selectedExpiredDiscount.status 					= selected_data.status;
			selectedExpiredDiscount.is_active 				= selected_data.is_active;

			updateExpiredDiscountModal.value.setContent(selectedExpiredDiscount);
			updateExpiredDiscountModal.value.toggleModal();
		}

		const refreshExpiredDiscount = ()=>{
			formReload.get(route('admin.user-management.members.show', props.member.member_uuid),
					{
						preserveState: true,
						preserveScroll: true,
						only:['admin,member,expiredDiscount']
					});
		}

		const copyLink 	= (index)=>{
							var copy_link = $('#expired_link-'+index);
							copy_link.select();
							document.execCommand("copy");
							toast.show(copy_link.val()+' copied', { type: 'success'})

						};

		const createSpecialDiscount = () => {
			form.post(route('admin.user-management.post.expired-member-special-discount'), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					form.reset()
				},
			})
		}

		const resetToPending = (_index)=>{
			let data = props.expiredDiscount[_index];

			formReActivate.expired_discount_id 	= data.expired_discount_id;
			formReActivate.special_code 		= data.special_code;
			formReActivate.status 				= 'Pending';

			confirmReActivateModal.value.toggleModal();
		}

		const current_index = ref(0);
		const reSendEmail = (_index)=>{
			let data = props.expiredDiscount[_index];

			current_index.value = _index;

			formResend.username 			= props.member.username;
			formResend.special_code 		= data.special_code;
			formResend.generated_by 		= data.generated_by;
			formResend.fname 				= props.admin.fname;

			formResend.put(route('admin.user-management.put.expired-member-special-discount-resend',{expired_discount_id:data.expired_discount_id}), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					formResend.reset();
					current_index.value = 0;
				},
			})
		}

		const reActivation = () => {
			formReActivate.put(route('admin.user-management.put.expired-member-special-discount-reactivate',{expired_discount_id:formReActivate.expired_discount_id}), {
				// preserveState: true,
				// preserveScroll: true,
				onSuccess: () => {
					formReActivate.reset()
					confirmReActivateModal.value.toggleModal()
				},
			})
		}

		return {
			current_index,
			form,
			formReload,
			formReActivate,
			formResend,
			modal,
			toggleModal,
			selectExpiredDiscount,
			confirmReActivateModal,
			updateExpiredDiscountModal,
			selectedExpiredDiscount,
			refreshExpiredDiscount,
			copyLink,
			createSpecialDiscount,
			reSendEmail,
			resetToPending,
			reActivation,
		}
	},
}
</script>
